import { Typography } from "@mui/material";
import BaseModal from "@/pages/InvoiceManagement/v2/components/BaseModal";

interface WithdrawRfqModalProps {
  open: boolean;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function WithdrawRfqModal({ open, submitting, onClose, onConfirm }: WithdrawRfqModalProps) {
  return (
    <BaseModal open={open} title="Withdraw your response?" confirmLabel="Yes, withdraw" cancelLabel="Keep response" loading={submitting} onClose={onClose} onConfirm={onConfirm}>
      <Typography fontSize="13px">
        Withdrawing takes your response out of evaluation until you submit again. Your rates stay filled in, so edit them and submit before the deadline.
      </Typography>
    </BaseModal>
  );
}
